import Vue from "vue";
const { getInfo } = {};
import { login, studentLogin, logout } from "@api/recruit/user/acl";
import {
  removeAccessToken,
  setAccessToken,
  getAccessToken,
} from "@/utils/accessToken";
import router, { resetAnonymousRouter } from "@/router";
import { title, tokenName } from "@/config/settings";
import { encryptedData } from "@/utils/encrypt";
import store from "@/store";

const state = {
  accessToken: getAccessToken(),
  // accessToken: "",
  userName: "",
  userCode: "",
  userPhone: "",
  cardNumber: "",
  email: "",
  avatar: "",
  needLogin: true,
  deptCode: "",
  orgCode: "",
  curRole: "anonymous",
  permissions: [],
};
const getters = {
  accessToken: (state) => state.accessToken,
  userName: (state) => state.userName,
  userCode: (state) => state.userCode,
  avatar: (state) => state.avatar,
  deptCode: (state) => state.deptCode,
  userPhone: (state) => state.userPhone,
  cardNumber: (state) => state.cardNumber,
  email: (state) => state.email,
  orgCode: (state) => state.orgCode,
  permissions: (state) => state.permissions,
  needLogin: (state) => state.needLogin,
  curRole: (state) => state.curRole,
};
const mutations = {
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken;
    setAccessToken(accessToken);
  },
  setUserName(state, userName) {
    state.userName = userName;
  },
  setUserCode(state, userCode) {
    state.userCode = userCode;
  },
  setEmail(state, email) {
    state.email = email;
  },
  setCardNumber(state, cardNumber) {
    state.cardNumber = cardNumber;
  },
  setDeptCode(state, deptCode) {
    state.deptCode = deptCode;
  },
  setOrgCode(state, orgCode) {
    state.orgCode = orgCode;
  },
  setUserPhone(state, userPhone) {
    state.userPhone = userPhone;
  },
  setAvatar(state, avatar) {
    state.avatar = avatar;
  },
  setPermissions(state, permissions) {
    state.permissions = permissions;
  },
  setNeedLogin(state, needLogin) {
    state.needLogin = needLogin;
  },
  setCurRole(state, curRole) {
    state.curRole = curRole;
  },
};
const actions = {
  setPermissions({ commit }, permissions) {
    commit("setPermissions", permissions);
  },
  async login({ commit }, userInfo) {
    const { success, data, message } = await login({
      data: await encryptedData({
        userName: userInfo.username,
        password: userInfo.password,
      }),
    });
    if (success) {
      commit("setAccessToken", data[tokenName]);
      commit("setUserName", data.name);
      commit("setUserCode", data.code ? data.code : data.name);
      commit("setDeptCode", data.deptCode);
      commit("setOrgCode", data.orgCode);
      commit("setNeedLogin", false);
      let curRole = "user";
      const roles = data.roles;
      if (roles && roles.length > 0) {
        if (roles.some((value) => value == "xtgly")) {
          curRole = "admin";
        } else if (roles.some((value) => value == "rlzygly")) {
          curRole = "hrAdmin";
        } else if (roles.some((value) => value == "rlzyxxlly")) {
          curRole = "hr";
        } else if (roles.some((value) => value == "student")) {
          curRole = "user";
        }
      } else {
        curRole = "anonymous";
      }
      commit("setCurRole", curRole);
      const hour = new Date().getHours();
      const thisTime =
        hour < 8
          ? "早上好"
          : hour <= 11
          ? "上午好"
          : hour <= 13
          ? "中午好"
          : hour < 18
          ? "下午好"
          : "晚上好";
      Vue.prototype.$baseNotify(`欢迎登录${title}`, `${thisTime}！`);
    } else {
      Vue.prototype.$baseMessage(`登录异常，${message}`, "error");
    }
    return success;
  },
  async studentLogin({ commit }, userInfo) {
    const { success, data, message } = await studentLogin({
      data: await encryptedData({
        userName: userInfo.username,
        password: userInfo.password,
      }),
    });
    if (success) {
      commit("setAccessToken", data[tokenName]);
      commit("setUserName", data.name);
      commit("setUserCode", data.code ? data.code : data.name);
      commit("setUserPhone", data.mobile);
      commit("setCardNumber", data.cardNumber);
      commit("setEmail", data.email);
      commit("setNeedLogin", false);
      commit("setCurRole", "anonymous");
      const hour = new Date().getHours();
      const thisTime =
        hour < 8
          ? "早上好"
          : hour <= 11
          ? "上午好"
          : hour <= 13
          ? "中午好"
          : hour < 18
          ? "下午好"
          : "晚上好";
      Vue.prototype.$baseNotify(`欢迎登录${title}`, `${thisTime}！`);
    } else {
      Vue.prototype.$baseMessage(`登录异常，${message}`, "error");
    }
    return success;
  },
  async getInfo({ commit, state }) {
    const { data, success, msg } = await getInfo({ usercode: state.usercode });
    if (!success) {
      Vue.prototype.$baseMessage("验证失败，请重新登录...", "error");
      return false;
    }
    let { name, avatar } = data;
    if (name) {
      commit("setUserName", name);
      commit("setPermissions", ["admin"]);
      commit("setAvatar", avatar);
      return ["admin"];
    } else {
      Vue.prototype.$baseMessage("获取用户信息接口异常", "error");
      return false;
    }
  },
  async logout({ dispatch }) {
    await logout({ username: state.username });
    await dispatch("tagsBar/delAllRoutes", null, { root: true });
    await dispatch("resetAccessToken");
    await resetAnonymousRouter();
    store.dispatch("routes/setRoutes", "anonymous");
  },
  async resetAccessToken({ commit }) {
    commit("setPermissions", []);
    commit("setAccessToken", "");
    commit("setUserName", "");
    commit("setUserCode", "");
    commit("setDeptCode", "");
    commit("setOrgCode", "");
    commit("setUserPhone", "");
    commit("setCardNumber", "");
    commit("setEmail", "");
    commit("setNeedLogin", true);
    commit("setCurRole", "anonymous");
    removeAccessToken();
  },
  async resetUserInfo({ commit }, userInfo) {
    let roles = userInfo.roles;
    let curRole = "anonymous";
    if (roles instanceof Array) {
      if (roles) {
        if (roles.some((value) => value == "xtgly")) {
          curRole = "admin";
        } else if (roles.some((value) => value == "rlzygly")) {
          curRole = "hrAdmin";
        } else if (roles.some((value) => value == "rlzyxxlly")) {
          curRole = "hr";
        } else if (roles.some((value) => value == "student")) {
          curRole = "user";
        }
      }
    }
    commit("setPermissions", ["admin"]);
    commit("setUserName", userInfo.name);
    commit("setUserCode", userInfo.code ? userInfo.code : userInfo.name);
    commit("setUserPhone", userInfo.mobile);
    commit("setCardNumber", userInfo.cardNumber);
    commit("setEmail", userInfo.email);
    commit("setNeedLogin", false);
    commit("setDeptCode", userInfo.deptCode);
    commit("setOrgCode", userInfo.orgCode);
    commit("setCurRole", curRole);
  },
};
export default { state, getters, mutations, actions };
